<script setup>
import { Head } from '@inertiajs/vue3'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TutorProfile from '@/Components/Tutors/TutorProfile.vue'

/**
 * The same tutor profile, for a signed-in student.
 *
 * It used to be a separate page that had drifted into a different layout, so
 * the profile that persuaded someone to sign up looked nothing like the one they
 * saw afterwards. Both routes now render TutorProfile; the only difference is
 * the frame around it, which is the one thing that should differ — a signed-in
 * student keeps their own navigation.
 *
 * The profile already adapts to being signed in on its own: the contact card
 * links to an existing conversation rather than offering an enquiry, and a plan
 * the student is subscribed to is marked as theirs.
 */
defineProps({
  tutor: { type: Object, required: true },
  availability: { type: Array, default: () => [] },
  availabilityLegend: { type: Array, default: () => [] },
  subscriptions: { type: Array, default: () => [] },
})
</script>

<template>
  <Head>
    <title>{{ tutor.name }} — Bindle tutor</title>
  </Head>

  <DashboardLayout>
    <TutorProfile
      :tutor="tutor"
      :availability="availability"
      :availability-legend="availabilityLegend"
      :subscriptions="subscriptions"
    />
  </DashboardLayout>
</template>
